import $ from "jquery";

const toggleSlide = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            button: ".js-toggle-slide",
            TermCondition: ".TermCondition",
        };

        $(document).on("click", el.button, function (e) {
            e.preventDefault();

            const targetEl = $(this).data("for");
            const currentClassToggle = $(this).data("toggle_class");

            if (currentClassToggle) {
                $(this).toggleClass(currentClassToggle);
            }

            // if current page is term and condition
            if ($(el.TermCondition).length > 0) {
                $(".TermAccordion__Content").not(targetEl).slideUp();

                // Remove the class from all buttons except the current one
                $(el.button).not(this).removeClass(currentClassToggle);
            }

            $(targetEl).slideToggle(currentClassToggle);
        });
    };

    init();
};

try {
    toggleSlide();
} catch (error) {
    console.error("toggleSlide: ", toggleSlide);
}
